import React from "react";
import { Link } from "react-router-dom";
import aboutData from "../data/aboutData";
import useScrollAnimation from "../../hooks/useScrollAnimation";
export default function About() {
    useScrollAnimation();

    const showData = aboutData.map((el, index) =>
        <div key={index} className="js-scroll fade-top w-100 card cursor-pointer flex flex-col gap-[7px] justify-center items-center h-[270px] w-[30%] p-5 shadow-[0px_0px_10px_#0000004d] rounded-lg gap-[20px] transition duration-500">
            <div className="w-[70px] h-[70px] bg-[#294a6a] rounded-full flex items-center justify-center">
                <img className="w-[45px] h-[45px]" src={el.image} alt="" />
            </div>
            <div className="flex flex-col gap-[7px] text-center">
                <div className="font-bold text-[19px]">{el.title}</div>
                <p className="text-[14px]">
                    {el.description}
                </p>
            </div>
        </div>
    )

    return (
        <>
            <section className="landingpages">
                <div className="container h-[75%] flex flex-col gap-[5px] items-center justify-center">
                    <div className="text-white font-bold capitalize text-[40px] btmAni2000">About us</div>
                    <div className="flex items-center text-[20px] gap-[4px] text-white btmAni25002">
                        <Link className="text-white" to={"/"}>Home</Link>
                        -
                        <span className="text-white">About us</span>
                    </div>
                </div>
            </section>
            <section className="py-[40px]">
                <div className="container flex flex-col gap-[40px]">
                    <div className="f-col flex items-center justify-between gap-[20px]">
                        <div className="w-100 flex flex-col gap-[5px] w-[48%]">
                            <div className="font-bold text-[#294a6a] text-[35px] capitalize btmAni2000">Who we are</div>
                            <p className="btmAni25002">
                                At M Power Moving Services, no job is too big or too small.
                                What began as a small local moving service has grown into a
                                trusted name for both local and long-distance moves across the U.S.
                                With our expertise, commitment, and top-tier resources, we ensure
                                every move is smooth, efficient, and stress-free.
                            </p>
                            <div className="font-bold text-[#294a6a] text-[35px] capitalize btmAni2000">Our Mission</div>
                            <p className="btmAni25002">
                                Our mission is to transport your belongings safely
                                and efficiently from Point A to Point B, making any
                                necessary stops along the way, while ensuring the highest level of care and integrity.
                            </p>
                        </div>
                        <div>
                            <img className="btmAni20002 w-100 w-[350px] h-[350px]" src={require("../../assets/image/about.png")} alt="" />
                        </div>
                    </div>
                    <div className="f-col flex flex-wrap gap-[30px]">
                        {showData}
                    </div>
                </div>
            </section>
        </>
    );
}